<template>
  <Card
    background="copy"
    color="background"
    direction="row"
    :title="`Grade this question⬆ (Maximum Score of ${maximumScore})`"
  >

    <Stack spacing="tad" align="center" direction="row">
      <Select
          :options="options"
          style="color: black; min-width: 200px"
          name="grade"
          v-model="score"
          :disabled="loading"
          placeholder="Grade to assign"
      />
      <Button :disabled="score.length === 0 || saved" :loading="loading" @click="submit">
        {{ saved ? 'Submitted' : 'Submit'}}
      </Button>
    </Stack>
  </Card>
</template>

<script>
  import Button from '@hackthe6ix/vue-ui/Button';
  import Select from '@hackthe6ix/vue-ui/Select';
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import Card from '../../../../containers/Card';

  export default {
  name: 'Grade',
  components: {
    TextComponent,
    Stack,
    Select,
    Card,
    Button
  },
  props: {
    category: String,
    currentState: Object,
    maximumScore: Number,
    updateScore: Function
  },
  data() {
    return {
      score: "",
      reviewer: "",
      loading: false,
      saved: false
    }
  },
  watch: {
    score() {
      this.saved = false;
    }
  },
  computed: {
    options() {
      const out = [];

      for (let i = 0; i <= this.maximumScore; i++) {
        out.push(i.toString());
      }

      return out;
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      await this.updateScore(this.score, this.category);

      this.loading = false;
      this.saved = true;
    }
  },
  beforeMount() {
    this.score = this.currentState.score === -1 ? "" : this.currentState.score.toString();
    this.reviewer = this.currentState.reviewer;
  }
};
</script>
